import { parseFiniteNumberString } from '@omnea-app/packages/universal/number-utils/parseFiniteNumberString'
import { type FilterOperator, isRangeOperator } from './filterOperators'

export const DEFAULT_NUMERIC_FILTER_OPERATOR: FilterOperator = 'gt'

const numericFilterArity = (operator: FilterOperator): 1 | 2 => (isRangeOperator(operator) ? 2 : 1)

/** A single-value operator's operand is both `low` and `high`. */
export type NumericFilterOperands = { low: number; high: number }

/**
 * The operands a numeric filter compares against, or null while any is missing or not a finite
 * number. A range's bounds come back ordered, so the order they were typed in never matters.
 */
export const numericFilterOperands = (operator: FilterOperator, values: string[] | null): NumericFilterOperands | null => {
  if (values == null || values.length !== numericFilterArity(operator)) return null
  const operands = values.map(parseFiniteNumberString).filter((value) => value !== null)
  if (operands.length !== values.length) return null
  return { low: Math.min(...operands), high: Math.max(...operands) }
}
